import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import appReducer from '../reducers/app.reducer';
import dndAppReducer from '../reducers/dnd-app.reducer';
import AuthorizationReducer from '../reducers/authorization.reducer';
import AlertMessageDialogReducer from '../reducers/alert-message-dialog.reducer';
import GLOBAL_CONFIG from '../config/config';
import appModalReducer from '../reducers/app-modal.reducer';
import loginModalReducer from '../reducers/login-modal.reducer';
import otpModalReducer from '../reducers/otp-modal.reducer';
import ssoModalReducer from '../reducers/sso-modal.reducer';
import dndRegistrationReducer from '../reducers/dnd-registration.reducer';
import dndComplaintInfo from '../reducers/dnd-complaint.reducer';
import { consentAppReducer } from '../reducers/consent-app.reducer';
import { consentInfoReducer } from '../reducers/consent-info.reducer';
import { SnackBarReducer } from '../reducers/snack-bar.reducer';
const middleware = [thunk];
const rootReducer = combineReducers({
    //user auth reducer for /login redirect
    userInfo: AuthorizationReducer,

    app: appReducer,

    //common message dialog
    alertMessageDialog: AlertMessageDialogReducer,

    //common dnd app related flags
    dndapp: dndAppReducer,

    //common modal 
    modalInfo: appModalReducer,

    //login modal info
    loginModalInfo: loginModalReducer,

    //otp modal info
    otpModalInfo: otpModalReducer,

    //sso modal info
    ssoModalInfo: ssoModalReducer,

    //dnd registration user
    registrationInfo: dndRegistrationReducer,

    //dnd complaint info
    complaintInfo: dndComplaintInfo,

    //consent app related flags and active page info
    consentApp: consentAppReducer,

    //consent info 
    consentInfo: consentInfoReducer,

    //SnackBar Info
    snackBar: SnackBarReducer

})

const createDevStore = () => {
    return createStore(
        rootReducer,
        compose(
            applyMiddleware(...middleware),
            // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        )
    );
}

const createStagingStore = () => {
    return createProdStore();
}

const createProdStore = () => {
    return createStore(
        rootReducer,
        compose(
            applyMiddleware(...middleware)
            //  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        )
    );
}

const store = GLOBAL_CONFIG.env === 'prod' ? createProdStore() : GLOBAL_CONFIG.env === 'staging' ? createStagingStore() : createDevStore();



export default store; 